var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79079 -0.000314652L10.2108 -0.000313915C10.5432 -0.000795492 10.869 0.0928716 11.1503 0.269845C11.4317 0.446818 11.6572 0.699861 11.8008 0.999686C11.9688 1.35543 12.0335 1.75122 11.9876 2.14195C11.9416 2.53269 11.7868 2.90265 11.5408 3.20969L7.33079 8.30968C7.16557 8.50031 6.9613 8.6532 6.73183 8.75798C6.50236 8.86276 6.25305 8.91699 6.00079 8.91699C5.74852 8.91699 5.49921 8.86276 5.26974 8.75798C5.04027 8.6532 4.836 8.50031 4.67079 8.30968L0.460785 3.20968C0.214779 2.90265 0.0599714 2.53269 0.0140024 2.14195C-0.0319665 1.75122 0.0327546 1.35543 0.200787 0.999685C0.344329 0.699861 0.569845 0.446817 0.851233 0.269844C1.13262 0.0928707 1.45837 -0.000796286 1.79079 -0.000314652Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.80fb636700d2c88df5bf91c24b4fc5a6.svg";
export { ForwardRef as ReactComponent };